import { motion } from "framer-motion";
import { useEffect, createElement, useState } from "react";
import ReactPlayer from "react-player";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Config } from "../../../config/config";
import { BubbleAnimation } from "../../../components/bubble";
import "./project-popup.css";
import ReactMarkdown from "react-markdown";

const YoutubeSlide = ({ url, playing }) => (
  <ReactPlayer
    className="carousel-player"
    width="100%"
    // height="100%"
    url={url.url}
    playing={playing}
    controls
    // style={{ paddingBottom: "1%" }}
  />
);

export const ProjectPopup = ({ isOpen, onClose, project }) => {
  const containerVariants = {
    open: {
      opacity: 1,
      transition: { duration: 0.2, ease: "easeOut" },
      position: "fixed",
      top: 0,
    },
    closed: {
      opacity: 0,
      transition: { duration: 0.2, ease: "easeIn" }
    },
  };

  const modalVariants = {
    open: {
      opacity: 1,
      scale: 1,
      y: 0,
      transition: { duration: 0.3, ease: "easeOut" },
      position: "fixed",
      top: 0,
    },
    closed: {
      opacity: 0,
      scale: 0.9,
      y: 50,
      transition: { duration: 0.3, ease: "easeIn" }
    },
  };

  const customRenderItem = (item, props) =>
    createElement(item.type, { ...item.props, ...props });

  const getVideoThumb = (videoId) =>
    `https://img.youtube.com/vi/${videoId}/default.jpg`;

  const getVideoId = (url) =>
    url.substr("https://www.youtube.com/embed/".length, url.length);

  const customRenderThumb = (children) =>
    children.map((item) => {
      const videoId = getVideoId(item.props.url.url);
      return <img onClick={(event) => event.stopPropagation} src={getVideoThumb(videoId)} />;
    });

  const [isPlaying, setIsPlaying] = useState(false);

  const handleClose = () => {
    setIsPlaying(false);
    onClose();
  };

  useEffect(() => {
    if (isOpen === false) {
      setIsPlaying(false);
    }
  }, [isOpen]);

  // Don't render if no project or popup is not open
  if (!project || !isOpen) {
    return null;
  }

  return (
    <motion.div
      className="popup fixed inset-0 bg-opacity-75 z-40"
      initial="closed"
      animate={isOpen ? "open" : "closed"}
      variants={containerVariants}
      // onClick={handleClose}
    >
      <div className="container-popup mx-auto w-full h-full"  >
        <motion.div
          className="bg-black rounded-lg p-8 w-full h-full top-0"
          initial="closed"
          animate={isOpen ? "open" : "closed"}
          // onClick={handleClose}
          variants={modalVariants}
        >
          <BubbleAnimation triggerOnce={false}>
            {project.brand ? (
              <img
                className="mx-auto"
                src={Config.api.mediaUrl + project.brand}
                alt={project.title}
                width={150}
                height={150}
              />
            ) : (
              <div className="mx-auto my-4 w-[150px] h-[150px] bg-gray-800 rounded-xl flex items-center justify-center mb-10">
                <span className="text-white text-sm">No logo</span>
              </div>
            )}
          </BubbleAnimation>
          {project.youtube_urls && project.youtube_urls.length > 0 ? (
            <Carousel
              showThumbs={true}
              showIndicators={false}
              thumbWidth={150}
              dynamicHeight={false}
              renderItem={customRenderItem}
              renderThumbs={customRenderThumb}
              className="carousel-custom"
            >
              {project.youtube_urls.map((video, index) => (
                <YoutubeSlide
                  key={"youtube-" + index + project.id}
                  url={video}
                  playing={isPlaying}
                  className="carousel-player"
                />
              ))}
            </Carousel>
          ) : (
            <div className="flex items-center justify-center h-64 text-white">
              <p>No videos available for this project</p>
            </div>
          )}
          <div 
          onClick={handleClose}
           className="flex justify-center items-center project-desc p-8" >
            <br />
            <ReactMarkdown
              className="text-white mt-14 text-2xl text-left w-full leading-tight flex-1"
              escapeHtml={false}
              components={{
                strong: ({ node, ...props }) => (
                  <span className="text-strong text-[15pt]" {...props} />
                ),
              }}
            >
              {project.description}
            </ReactMarkdown>
          </div>
          <button
            className="absolute top-0 right-0 m-8 text-white text-4xl font-bold cursor-pointer"
            onClick={handleClose}
          >
            &#10005;
          </button>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default ProjectPopup;
